import {API_URLS} from '@/const/urls';
import {http} from '@/helper/http';

export const memeApi = {
  getFunds(query) {
    return http.get(API_URLS.MEME_HISTORY_FUNDS, {query});
  },
  getMemeList(query) {
    return http.get(API_URLS.MEME_LIST, {
      query: {
        ...query,
      },
    });
  },
  getMemeListUpdate(query, isLogin) {
    return http.get(API_URLS[isLogin ? 'MEME_LIST_UPDATE' : 'MEME_PUBLIC_LIST_UPDATE'], {
      query,
    });
  },
};
